import {Operator, UrlParameter, UrlParameterType} from '../../../shared/utils/url.builder';
import {Moment} from 'moment';
import {StringUtils} from '../../../shared/utils/string.utils';
import * as moment from 'moment-timezone';

export class UrlParameterBuilder {
    readonly parameters: UrlParameter[] = [];

    addParameterSimple(parameter: UrlParameter): UrlParameterBuilder {
        if (parameter === undefined || parameter == null) {
            return this;
        }
        this.parameters.push(parameter);
        return this;
    }

    addParametersSimple(parameters: UrlParameter[]): UrlParameterBuilder {
        if (parameters?.length > 0) {
            parameters.forEach(parameters => this.addParameterSimple(parameters));
        }
        return this;
    }

    addParameter(parameterName: string, parameterValue: UrlParameterType, operator = Operator.EQUALS): UrlParameterBuilder {
        // console.log(['addParameter', parameterName, parameterValue]);
        if (parameterValue === undefined || parameterValue == null || parameterValue === '') {
            return this;
        }
        this.parameters.push(new UrlParameter(parameterName, parameterValue, operator));
        return this;
    }
    addNullParameter(parameterName: string): UrlParameterBuilder {
        return this.addParameter(parameterName, 'null', Operator.EQUALS);
    }
    addNotNullParameter(parameterName: string): UrlParameterBuilder {
        return this.addParameter(parameterName, 'null', Operator.NOT);
    }

    addInParameter(parameterName: string, values: string[] | number[]): UrlParameterBuilder {
        if (!values || values?.length === 0) {
            return this;
        }
        this.addParameter(parameterName, StringUtils.join(',', values), Operator.IN);
        return this;
    }
    addNotInParameter(parameterName: string, values: string[]): UrlParameterBuilder {
        if (!values || values?.length === 0) {
            return this;
        }
        this.addParameter(parameterName, StringUtils.join(',', values), Operator.NOT_IN);
        return this;
    }

    addMomentBetweenParameter(parameterName: string, from: Moment, to: Moment): UrlParameterBuilder {
        return this.addBetweenParameter(parameterName, this.formatMomentValue(from), this.formatMomentValue(to));
    }

    addMomentParameter(parameterName: string, moment: Moment, operator: Operator): UrlParameterBuilder {
        return this.addParameter(parameterName, this.formatMomentValue(moment), operator);
    }

    addBetweenParameter(parameterName: string, from: any, to: any): UrlParameterBuilder {
        // console.log(['addBetweenParameter', parameterName, from, to])
        if (from && to) {
            this.addParameter(parameterName, from + ',' + to, Operator.BETWEEN);
        } else if (from) {
            this.addParameter(parameterName, from, Operator.GREATER_OR_EQUAL);
        } else if (to) {
            this.addParameter(parameterName, to, Operator.LESS_OR_EQUAL);
        }
        return this;
    }

    private formatMomentValue(momentValue: Moment): string {
        if (!momentValue) {
            return undefined;
        }
        try {
            return '' + (momentValue.unix() * 1000);
        } catch (ex) {
            return '' + moment(momentValue).unix() * 1000;
        }
    }
}
